/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentDeliveryPlan } from 'app/shared/model/treatment-delivery-plan.model';
import { ITreatmentRegimen } from 'app/shared/model/treatment-regimen.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';
import { IRegimenInvestigation } from 'app/shared/model/regimen-investigation.model';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';

export interface ITreatmentRegimenInvestigation {
  id?: string;
  cycleNumber?: number | null;
  associationType?: keyof typeof AssociationType | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  plan?: ITreatmentDeliveryPlan | null;
  regimen?: ITreatmentRegimen | null;
  cycle?: ITreatmentCycle | null;
  metaDiagnosis?: IRegimenInvestigation | null;
}

export const defaultValue: Readonly<ITreatmentRegimenInvestigation> = {
  active: false,
};
